var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { context, trace, SpanStatusCode } from '@opentelemetry/api';
import { ATTR_EXCEPTION_MESSAGE, ATTR_EXCEPTION_STACKTRACE, ATTR_EXCEPTION_TYPE, } from '@opentelemetry/semantic-conventions';
import { getResourceAttributes } from './set-resource-attributes';
/**
 * @description Add error to current span
 * @param {Error} error
 * @returns {void}
 */
export var captureException = function (error, errorInfo) {
    var _a, _b;
    if (!error || !shouldCaptureException(error)) {
        return;
    }
    var activeContext = context.active();
    var span = trace.getSpan(activeContext);
    var isNewSpan = false;
    if (!span || !span.isRecording()) {
        span = trace.getTracer('exception').startSpan(error.name || 'Error', {
            attributes: __assign((_a = {}, _a[ATTR_EXCEPTION_MESSAGE] = error.message, _a[ATTR_EXCEPTION_STACKTRACE] = error.stack, _a[ATTR_EXCEPTION_TYPE] = error.name, _a), getResourceAttributes()),
        });
        trace.setSpan(activeContext, span);
        isNewSpan = true;
    }
    else {
        span.setAttributes((_b = {},
            _b[ATTR_EXCEPTION_MESSAGE] = error.message,
            _b[ATTR_EXCEPTION_STACKTRACE] = error.stack,
            _b[ATTR_EXCEPTION_TYPE] = error.name,
            _b));
    }
    if (errorInfo) {
        Object.entries(errorInfo).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            span.setAttribute("error_info.".concat(key), value);
        });
    }
    span.recordException(error);
    span.setStatus({
        code: SpanStatusCode.ERROR,
        message: error.message,
    });
    if (isNewSpan) {
        span.end();
    }
};
/**
 * Best-effort deduplication of exceptions that fire multiple times
 * (e.g. framework handler + global handlers) within a short time window.
 */
var exceptionDedupeWindowMs = 2000;
var recentExceptionFingerprints = new Map();
export var shouldCaptureException = function (error, _errorInfo) {
    var e_1, _a;
    if (!error)
        return false;
    var now = Date.now();
    // Build a fingerprint that is stable enough across repeated emissions
    // but not so broad that different errors collapse into one.
    var keyParts = [];
    keyParts.push(error.name || 'Error');
    keyParts.push(error.message || '');
    // First stack line tends to include file/line where it originated.
    if (typeof error.stack === 'string') {
        var firstFrame = error.stack.split('\n')[1] || '';
        keyParts.push(firstFrame.trim());
    }
    var fingerprint = keyParts.join('|').slice(0, 500);
    var lastSeen = recentExceptionFingerprints.get(fingerprint);
    if (lastSeen && now - lastSeen < exceptionDedupeWindowMs) {
        return false;
    }
    recentExceptionFingerprints.set(fingerprint, now);
    try {
        // Cheap cleanup of old entries to avoid unbounded growth.
        for (var recentExceptionFingerprints_1 = __values(recentExceptionFingerprints), recentExceptionFingerprints_1_1 = recentExceptionFingerprints_1.next(); !recentExceptionFingerprints_1_1.done; recentExceptionFingerprints_1_1 = recentExceptionFingerprints_1.next()) {
            var _b = __read(recentExceptionFingerprints_1_1.value, 2), key = _b[0], ts = _b[1];
            if (now - ts > exceptionDedupeWindowMs * 5) {
                recentExceptionFingerprints.delete(key);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (recentExceptionFingerprints_1_1 && !recentExceptionFingerprints_1_1.done && (_a = recentExceptionFingerprints_1.return)) _a.call(recentExceptionFingerprints_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
};
//# sourceMappingURL=capture-exception.js.map